var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPostTripInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.5C8.85652 0.5 10.637 1.2375 11.9497 2.55025C13.2625 3.86301 14 5.64348 14 7.5C14 9.35652 13.2625 11.137 11.9497 12.4497C10.637 13.7625 8.85652 14.5 7 14.5C5.14348 14.5 3.36301 13.7625 2.05025 12.4497C0.737498 11.137 0 9.35652 0 7.5C0 5.64348 0.737498 3.86301 2.05025 2.55025C3.36301 1.2375 5.14348 0.5 7 0.5ZM7 5.75C7.09849 5.75 7.19602 5.7306 7.28701 5.69291C7.37801 5.65522 7.46069 5.59997 7.53033 5.53033C7.59997 5.46069 7.65522 5.37801 7.69291 5.28701C7.7306 5.19602 7.75 5.09849 7.75 5C7.75 4.90151 7.7306 4.80398 7.69291 4.71299C7.65522 4.62199 7.59997 4.53931 7.53033 4.46967C7.46069 4.40003 7.37801 4.34478 7.28701 4.30709C7.19602 4.2694 7.09849 4.25 7 4.25C6.80135 4.25 6.61084 4.32891 6.47038 4.46938C6.32991 4.60984 6.251 4.80035 6.251 4.999C6.251 5.19765 6.32991 5.38816 6.47038 5.52862C6.61084 5.66909 6.80135 5.748 7 5.748M7.5 6.998C7.5 6.86539 7.44732 6.73821 7.35355 6.64445C7.25979 6.55068 7.13261 6.498 7 6.498C6.86739 6.498 6.74021 6.55068 6.64645 6.64445C6.55268 6.73821 6.5 6.86539 6.5 6.998V9.998C6.5 10.1306 6.55268 10.2578 6.64645 10.3516C6.74021 10.4453 6.86739 10.498 7 10.498C7.13261 10.498 7.25979 10.4453 7.35355 10.3516C7.44732 10.2578 7.5 10.1306 7.5 9.998V6.998Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostTripInfoIcon);
export default __webpack_public_path__ + "static/media/postTripInfoIcon.c1765b2b9eb742d7535ec0abc51f76e4.svg";
export { ForwardRef as ReactComponent };